import { render, staticRenderFns } from "./SendingInfo.vue?vue&type=template&id=1c08dec8"
import script from "./SendingInfo.vue?vue&type=script&lang=js"
export * from "./SendingInfo.vue?vue&type=script&lang=js"
import style0 from "./SendingInfo.vue?vue&type=style&index=0&id=1c08dec8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports